export const aud = (n: number | null | undefined) => n == null ? "—" : n.toLocaleString("en-AU", { style: "currency", currency: "AUD", maximumFractionDigits: 0 });
/** Money to the cent. A pricing figure is never rounded for display: the customer
 *  reads the number the engine produced, with GST split exactly as the engine split it. */
export const money = (n: number | null | undefined) => n == null ? "—" : n.toLocaleString("en-AU", { style: "currency", currency: "AUD", minimumFractionDigits: 2, maximumFractionDigits: 2 });
export const m2 = (n: number | null | undefined) => n == null ? "—" : `${n.toLocaleString("en-AU", { maximumFractionDigits: 1 })} m²`;
export const day = (iso: string | null | undefined) => iso ? new Date(iso).toLocaleDateString("en-AU", { weekday: "short", day: "numeric", month: "short", timeZone: "Australia/Sydney" }) : "—";
export const time = (iso: string | null | undefined) => iso ? new Date(iso).toLocaleTimeString("en-AU", { hour: "2-digit", minute: "2-digit", timeZone: "Australia/Sydney" }) : "—";
export const todayLong = (d = new Date()) => d.toLocaleDateString("en-AU", { weekday: "long", day: "numeric", month: "long", year: "numeric", timeZone: "Australia/Sydney" });

/** "2 h 10 min" style age, negative = overdue */
export function ago(iso: string | null | undefined, now = Date.now()): string {
  if (!iso) return "—";
  const ms = now - new Date(iso).getTime();
  const m = Math.round(Math.abs(ms) / 60000);
  const s = m < 60 ? `${m} min` : m < 60 * 24 ? `${Math.floor(m / 60)} h ${m % 60} min` : `${Math.floor(m / 1440)} d`;
  return ms < 0 ? `in ${s}` : s;
}

export const SOURCE_LABEL: Record<string, string> = {
  hipages: "HiPages", trade_network: "Trade network", referral: "Referral", website: "Website", email: "Email enquiry / 电邮询价", sourced: "Sourced", profit_share: "Profit share", none: "No source",
};
export const sourceLabel = (s: string | null | undefined) => (s && SOURCE_LABEL[s]) || s || "—";

export const STAGES = ["New", "Quoted", "Pending Schedule", "Installation Scheduled", "Invoiced", "Fully Paid"] as const;
export const SIDE_STAGES = ["Stalled", "Lost"] as const;
export const STAGE_GROUP: Record<string, string> = {
  New: "Pipeline", Quoted: "Pipeline", "Project Bidding": "Pipeline", "SMG Pending": "Pipeline",
  "Pending Schedule": "Fulfillment", "Installation Scheduled": "Fulfillment", Invoiced: "Invoicing", "Fully Paid": "Completed", Stalled: "Lost", Lost: "Lost",
};
